import React, { Children, useState } from "react";
import ChevronUpIcon from "@/icons/ChevronUpIcon";
import ChevronDownIcon from "@/icons/ChevronDownIcon";
import styles from "./collapsible-list.module.css";

export default function CollapsibleList({
  items = [],
  children,
  count = 3,
  width = 300,
  wrap = false,
}) {
  const [expanded, setExpanded] = useState(false);

  const listItems = children ? Children.toArray(children) : items;
  const visibleItems = expanded ? listItems : listItems.slice(0, count);

  if (!listItems.length) return null;

  return (
    <div className={styles.container} style={{ maxWidth: width }}>
      {visibleItems.map((item, index) => (
        <div
          key={item?.key || index}
          className={wrap ? styles.itemWrap : styles.item}
        >
          {item}
        </div>
      ))}

      {listItems.length > count && (
        <div
          className={
            expanded ? styles.toggle_button_collapse : styles.toggle_button
          }
          onClick={() => setExpanded(!expanded)}
        >
          {expanded ? (
            <>
              <ChevronUpIcon style={{ fontSize: 14 }} /> <span>свернуть</span>
            </>
          ) : (
            <>
              <ChevronDownIcon style={{ fontSize: 14 }} />{" "}
              <span className={styles.toggle_button_text}>показать все</span>
            </>
          )}
        </div>
      )}
    </div>
  );
}
